import { GetApiPayloadByUrl, GetApiResponseByUrl } from '@crossbeam/openapi';

// SeatRequestRaw[number]['status'] is plain string, this one is more specific
export enum SeatRequestStatus {
  rejected = 'rejected',
  accepted = 'accepted',
  pending = 'pending',
}

export type SeatRequestRaw = GetApiResponseByUrl<'/v0.1/seat-requests'>;
export type SeatRequest = SeatRequestRaw[number];
// 'core' | 'sales' | null — integration is intentionally absent; seat requests predate that type
export type SeatType = SeatRequestRaw[number]['type'];

export const MAX_BULK_REJECT_SEAT_REQUESTS = 100;

export type BulkRejectSeatRequestsPayload = GetApiPayloadByUrl<
  '/v0.1/seat-requests-bulk',
  'patch'
>;
